import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import { a11yOnly } from "styles/global.css";

export default class LoadingStoriesNotice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: this.props.isLoading,
      noticeMessage: this.props.noticeMessage,
    };
  }

  static getDerivedStateFromProps(newProps, prevState) {
    if (newProps.isLoading === true) {
      return {
        isLoading: true,
        noticeMessage: "More stories loading.",
      };
    } else if (newProps.isLoading === false && prevState.isLoading === true) {
      return {
        isLoading: false,
        noticeMessage: "More stories loaded.",
      };
    } else {
      return prevState;
    }
  }

  render() {
    return (
      <div
        role="status"
        className={classNames({ [a11yOnly]: a11yOnly })}
        aria-live="polite"
      >
        {this.state.noticeMessage}
      </div>
    );
  }
}

LoadingStoriesNotice.defaultProps = {
  noticeMessage: "",
  isLoading: false,
};

LoadingStoriesNotice.propTypes = {
  noticeMessage: PropTypes.string,
  isLoading: PropTypes.bool,
};
